<template>
  <div class="conditions" :style="conStyle">
    <div class="con-list">
      <div
        class="con-item"
        v-for="(con, k) in conditions"
        :key="con._id"
        :title="formatCon(con.condition)"
      >
        <span class="con-item-word" @click="clickItem(con)">{{ con.name }}</span>
        <div class="con-item-action">
          <i class="el-icon-delete" @click="delCon(con, k)"></i>
        </div>
      </div>
    </div>
    <div class="con-mark" @click="toggle">
      <div class="con-mark-word">搜索条件</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: String,
    onClickItem: Function,
  },
  data: function () {
    return {
      conditions: [],
      showCon: false,
    }
  },
  computed: {
    conStyle: function () {
      let res = {
        left: this.showCon ? 0 : '-250px',
        zIndex: this.showCon ? 1002 : 1001,
      }
      return res
    },
  },
  methods: {
    loadCon: async function () {
      let res = await app.service('radish').listConditions()
      // console.log(res)
      if (res.status == 'success') {
        this.conditions = this.type ? res.data.filter(c => c.type == this.type) : res.data.filter(c => !c.type)
      } else {
        console.log(conditions.msg)
      }
    },
    delCon: function (con, k) {
      this.$confirm('确定删除搜索条件【' + con.name + '】吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await app.service('radish').deleteCondition({ _id: con._id })
          if (res.status == 'success') {
            this.conditions.splice(k, 1)
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          }
        })
        .catch(() => { })
    },
    formatCon: function (con) {
      let res = {}
      for (const key in con) {
        const val = con[key]
        if (key == '工作年限' && val[0] == 0 && val[1] == 30) {
          continue
        }
        if (val instanceof Array && val.length == 0) {
          continue
        }
        res[key] = val
      }
      return JSON.stringify(res)
    },
    toggle: function () {
      if (!this.showCon) {
        this.loadCon()
      }
      this.showCon = !this.showCon
    },
    clickItem: function (con) {
      if (this.onClickItem) {
        // console.log(1, con)
        this.onClickItem(con)
        this.showCon = false
      }
    },
  },
}
</script>
<style>
.conditions {
  /* display: none; */
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  height: 100vh;
  padding-top: 10px;
  border-right: 1px solid #e6e6e6;
  background-color: #fff;
  z-index: 1001;
}
.con-list {
  height: 100%;
  border-top: 1px solid #e6e6e6;
  overflow-y: auto;
}
.con-item {
  position: relative;
  display: flex;
  padding: 0 8px;
  border-bottom: 1px solid #e6e6e6;
  font-size: 14px;
  line-height: 40px;
  color: #666;
}
.con-item:hover {
  border-bottom: 2px solid #01487e;
}
.con-item-word {
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.con-item-word:hover {
  color: #409eff;
}
.con-item-action {
  display: none;
  position: absolute;
  top: 0;
  right: 0px;
  width: 50px;
  text-align: center;
  background-color: rgba(64, 158, 255, 0.9);
}
.con-item:hover > .con-item-action {
  display: block;
}
.con-item-action > i {
  cursor: pointer;
  color: #fff;
}
.con-item-action > i:hover {
  zoom: 1.1;
}
.con-mark {
  position: absolute;
  left: 250px;
  top: 175px;
  padding: 10px 8px 10px 5px;
  border-radius: 0 4px 4px 0;
  background-color: #01487e;
  color: #fff;
  cursor: pointer;
}
.con-mark-work {
  font-size: 20px;
  width: 20px;
  cursor: pointer;
}
</style>
